// @flow
import type { Actions, MtpStatus } from "./actions";

export type State = {
  mtpStatus: MtpStatus[],
  raceDate: string
};

export const initialState = {
  mtpStatus: [],
  raceDate: ""
};

export default function reducer(
  state: State = initialState,
  action: Actions
): State {
  switch (action.type) {
    case "MTP_STATUS_UPDATE": {
      return {
        ...state,
        mtpStatus: action.payload.mtpStatus,
        raceDate: action.payload.raceDate
      };
    }
    default: {
      return state;
    }
  }
}
